import React from 'react';
const RefundPolicy = () => {
  return <div className="min-h-screen bg-white" data-id="element-518">
      <div className="bg-mwc-burgundy text-white py-12" data-id="element-519">
        <div className="container mx-auto px-4" data-id="element-520">
          <h1 className="text-3xl font-bold text-center mb-4" data-id="element-521">Refund Terms</h1>
          <p className="text-lg text-center max-w-3xl mx-auto" data-id="element-522">
            Our fair and transparent terms regarding refunds for prepaid service
            packages
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-12" data-id="element-523">
        <div className="max-w-3xl mx-auto" data-id="element-524">
          <div className="bg-white rounded-lg shadow-md p-8" data-id="element-525">
            <div className="mb-8" data-id="element-526">
              <p className="text-gray-700" data-id="element-527">
                Maplewood-Care is committed to customer satisfaction. Our refund
                terms provide fair and clear guidelines for when refunds are
                applicable for our prepaid maintenance and repair service
                packages.
              </p>
            </div>
            <div className="mb-8" data-id="element-528">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-529">
                Service Package Refunds
              </h2>
              <div className="space-y-4" data-id="element-530">
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-531">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-532">
                    During the Cooling-Off Period (14 Days)
                  </h3>
                  <p className="text-gray-700" data-id="element-533">
                    If you cancel your prepaid service package within the 14-day
                    cooling-off period and have not requested any engineer
                    callouts or repair services, you will receive a full refund
                    of any payments made. This right is protected under UK
                    consumer protection regulations.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-534">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-535">
                    After the Cooling-Off Period
                  </h3>
                  <p className="text-gray-700" data-id="element-536">
                    For cancellations after the cooling-off period, refunds will
                    be calculated on a pro-rata basis for the remaining full
                    months of your service package, less a £25 administration
                    fee. The refund calculation will account for any services
                    already provided during the active period.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-537">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-538">
                    Service Usage Considerations
                  </h3>
                  <p className="text-gray-700" data-id="element-539">
                    No refund will be provided if you have requested engineer
                    callouts or repairs that, when valued at our standard
                    service rates (diagnostics, parts, and labour), equal or
                    exceed the total amount paid for your service package. This
                    ensures fair use of prepaid services.
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-8" data-id="element-540">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-541">
                Individual Service Call Refunds
              </h2>
              <div className="space-y-4" data-id="element-542">
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-543">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-544">
                    Unsatisfactory Repairs
                  </h3>
                  <p className="text-gray-700" data-id="element-545">
                    If you are not satisfied with a repair service provided,
                    please notify us within 7 days of the service completion. We
                    will arrange for a different engineer to assess the
                    situation and, if necessary, complete the repair work at no
                    additional cost. Our goal is to ensure all repairs meet
                    professional standards.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-546">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-547">
                    Unresolved Technical Issues
                  </h3>
                  <p className="text-gray-700" data-id="element-548">
                    If we cannot resolve the technical issue after a second
                    engineer visit, we will offer a full or partial refund for
                    that specific service call, depending on the work completed
                    and parts provided. We will work with you to find a fair
                    resolution.
                  </p>
                </div>
                <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-549">
                  <h3 className="font-semibold text-mwc-burgundy mb-2" data-id="element-550">
                    Non-Repairable Appliances
                  </h3>
                  <p className="text-gray-700" data-id="element-551">
                    For one-off repair services (outside of a prepaid package),
                    if our engineer determines that your appliance is beyond
                    economical repair and you have been charged a diagnostic
                    fee, this fee may be credited toward a replacement appliance
                    purchased through our recommended retail partners.
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-8" data-id="element-552">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-553">
                Processing of Refunds
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-554">
                <p className="text-gray-700 mb-4" data-id="element-555">
                  Approved refunds will be processed within 14 business days of
                  receiving your cancellation request and will be issued using
                  the same payment method used for the original transaction
                  unless otherwise agreed in writing.
                </p>
                <p className="text-gray-700" data-id="element-556">
                  For credit or debit card payments, please allow an additional
                  3-5 business days for the refund to appear in your account
                  after processing, depending on your card issuer's procedures.
                </p>
              </div>
            </div>
            <div data-id="element-557">
              <h2 className="text-2xl font-bold text-mwc-burgundy mb-4" data-id="element-558">
                How to Request a Refund
              </h2>
              <div className="bg-mwc-lightpink p-4 rounded-lg" data-id="element-559">
                <p className="text-gray-700 mb-4" data-id="element-560">
                  To request a refund, please contact our customer service team:
                </p>
                <ul className="list-disc pl-6 text-gray-700" data-id="element-561">
                  <li className="mb-2" data-id="element-562">
                    <span className="font-semibold" data-id="element-563">Phone:</span> 0800 055 4969
                    (Monday to Friday, 9am to 7pm; Saturday, 9am to 2pm)
                  </li>
                  <li data-id="element-564">
                    <span className="font-semibold" data-id="element-565">Email:</span>{' '}
                    support@maplewood-care.com
                  </li>
                </ul>
                <p className="text-gray-700 mt-4" data-id="element-566">
                  Please include your name, address, service package reference
                  number, and a brief explanation of your reason for requesting
                  a refund. We will respond to your request within 2 business
                  days.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default RefundPolicy;